import React, { createContext, useContext, useState } from 'react';

import { Snackbar } from 'common/components/Snackbar';
import { ISnackbarState } from 'common/interfaces/snackbarState';

interface ISnackbarContext {
    setSnackbarState(state: ISnackbarState): void;
}

const SnackbarContext = createContext<ISnackbarContext | null>(null);

export const SnackbarContextProvider: React.FC = ({ children }) => {
    const [snackbarState, setSnackbarState] = useState<ISnackbarState>({
        message: '',
        variant: 'error',
    });

    const resetSnackbarState = () => {
        setSnackbarState({
            ...snackbarState,
            message: '',
        });
    };

    return (
        <>
            <Snackbar
                {...snackbarState}
                open={!!snackbarState.message}
                onClose={resetSnackbarState}
            />
            <SnackbarContext.Provider value={{ setSnackbarState }}>
                {children}
            </SnackbarContext.Provider>
        </>
    );
};

export const useSnackbarContext = () => {
    const context = useContext(SnackbarContext);

    if (context === null) {
        throw new Error('context must be used within a provider');
    }

    return context;
};
